/**
 * FocusOnClick emits focus on target element
 */
import { Directive, HostListener } from '@angular/core';

type EventWithPath = Event & { path?: HTMLElement[] };

export enum AG_GRID_FOCUS_CLASS {
  FOCUS = 'ag-row-focus',
  NOFOCUS = 'ag-row-no-focus',
}

@Directive({
  selector: '[focus-on-click]',
  standalone: false,
})
export class FocusOnClickDirective {
  private targetElement: HTMLElement | null;

  @HostListener('click', ['$event'])
  public onClick(event: EventWithPath): void {
    const element: HTMLElement | null = this.findNearestRowInPath(event);

    if (element) {
      this.setFocus(element);
    }
  }

  private findNearestRowInPath({ path }: EventWithPath): HTMLElement | null {
    const pathExists = !!path && Array.isArray(path);
    if (pathExists) {
      return (
        path.find(
          (element: HTMLElement) =>
            element.getAttribute && element.getAttribute('role') === 'row',
        ) ?? null
      );
    }

    return null;
  }

  private removeFocus(): void {
    if (this.targetElement) {
      this.targetElement.classList.add(AG_GRID_FOCUS_CLASS.NOFOCUS);
      this.targetElement.classList.remove(AG_GRID_FOCUS_CLASS.FOCUS);
    }
    this.targetElement = null;
  }

  private setFocus(element: HTMLElement): void {
    if (this.targetElement) {
      this.removeFocus();
    }
    element.classList.remove(AG_GRID_FOCUS_CLASS.NOFOCUS);
    element.classList.add(AG_GRID_FOCUS_CLASS.FOCUS);
    this.targetElement = element;
  }
}
